/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import { Card } from '@akademi/ui';

interface Review {
  author: string;
  avatarInitials?: string;
  date: string;
  rating: number;
  text: string;
}

interface ReviewCardProps {
  review: Review;
  /** 'featured' is a bigger, quote-styled variant for Trust-first's
   *  pull-quote treatment above the fold. */
  featured?: boolean;
}

export function ReviewCard({ review, featured = false }: ReviewCardProps) {
  const initials = review.avatarInitials || getInitials(review.author);
  return (
    <Card asChild className={featured ? 'ring-0' : undefined}>
      <div className={featured ? 'cd-review cd-review-featured' : 'cd-review'}>
        <div className="cd-review-head">
          <div className="cd-review-avatar" aria-hidden>
            {initials}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="cd-review-author">{review.author}</div>
            <div className="cd-review-meta">{review.date}</div>
          </div>
          <div className="cd-review-stars" aria-label={`${review.rating} of 5 stars`}>
            {'★'.repeat(Math.round(review.rating))}
            {'☆'.repeat(5 - Math.round(review.rating))}
          </div>
        </div>
        <p className="cd-review-text">{featured ? `"${review.text}"` : review.text}</p>
      </div>
    </Card>
  );
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return ((parts[0]?.[0] ?? '') + (parts[parts.length - 1]?.[0] ?? '')).toUpperCase();
}
